
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.106 8.776c.42-.084 1.683-.335 1.977-.377h.001l.463-.713h-7.07l.126.755c.253 0 1.726.21 2.189.294-.054.43-1.373 1.5-2.4 2.334-.574.466-1.056.858-1.177 1.023a50.419 50.419 0 00-1.14-1.502c-.782-1.01-1.757-2.27-2.479-3.325.26-.07.916-.115 1.509-.155.465-.031.892-.06 1.058-.097l.126-.713H1.084L1 7.054c.178.036.605.094 1.057.155.617.084 1.28.174 1.426.223.925.714 4.502 5.205 4.67 5.667v2.518c0 .42-.336.588-.757.714-.42.126-1.136.21-1.6.168l-.083.755c.495.028 1.6.002 2.507-.02.48-.011.906-.021 1.154-.021.486 0 1.07-.005 1.642-.01 1.11-.01 2.175-.018 2.397.01l.084-.798-2.44-.168s-.042-2.938 0-3.19c.294-.797 4.586-4.155 5.049-4.28zm1.34 5.663l1.4.46v.002l3.526-5.7.628-.995-3.163-1.04-2.392 7.273zm-1.599 2.729l.964.267.903.297.701-1.522-.918-.252-.934-.357-.716 1.567z","fill":"#FF0132"}})])
          )
        }
      }
    